import { IRemoteExperienceService } from "@core/interface";
import { IDealerServiceHours } from "./dealer-service-hours.model";
import { IPreferreddealerType } from "./preferreddealer-type";

export interface IDealerByLocation extends IAddressDealerByLocation {
  dealerId: number;
  dealerName: string;
  dealerLocalName: string;
  distance: number;
  phone: string;
  latitude: number;
  longitude: number;
  pickupAndDelivery: boolean;
  winchService: boolean;
  serviceHours: IDealerServiceHours[];
  services: IRemoteExperienceService[];
  highestTimeWeek: string;
  lowestTimeWeek: string;
  highestTimeWeekend: string;
  lowestTimeWeekend: string;
  lowestDay: number;
  openSaturday: boolean;
  openSunday: boolean;
  preferredDealerType: IPreferreddealerType;
  dealerLocatorServices: string[];
  selected: boolean;
  acceptsOnlinePayments: boolean;
  mobileService: boolean;
  serviceSpecialist?: string;
  unSelectable?: boolean;

  // serviços remote experience FILTRADOS
  pdlModalityList: IRemoteExperienceService[];
  winchModalityList: IRemoteExperienceService[];
  msvModalityList: IRemoteExperienceService[];
}

export interface IAddressDealerByLocation {
  address: string;
  city: string;
  state: string;
  zipCode: string;
  countryCode: string;
}
